module.exports = __webpack_public_path__ + "img/Progress_on_diversity_issues_demands.bec5217f.jpg";